import { observer } from 'mobx-react';
import React from 'react';
import { useStores } from '../../stores/RootStore';
import DiilNews from '../diil/News';
import SuperNews from '../super/News';

const NewsContainer = observer((props: any): React.JSX.Element => {
  const { app } = useStores();

  if (app === 'super') {
    return <SuperNews {...props} />;
  }
  if (app === 'diil') {
    return <DiilNews {...props} />;
  }
  return null;
});

export default NewsContainer;
